
import { DataStation } from "@/types/datastation.type";
import { defineComponent } from "vue";
import { getDetailStation } from "@/service/station.service";
import {
  getDataHistoric,
  getDistinctMeasurements,
  isTextMeasurement,
} from "@/service/datastation.service";

interface DataItem {
  id: number | undefined;
  magnitude: string | undefined;
  measurement: string | undefined;
  unit: string | undefined;
  type: string | undefined;
}

// interface HistoryItem {
//   date: string;
//   value: string;
// }

export default defineComponent({
  props: {
    station: {
      type: String,
      required: true,
    },
    onParameterClick: {
      type: Function,
      required: true,
    },
    parameter: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      data: [] as DataItem[],
      stationDetail: [] as DataStation[] | undefined,
      magnitude: "" as string | undefined,
      historyData: [] as { date: string; value: string }[],
      isPopupVisible: false,
      parametersSelect: ["optical_operation", "state_SD", "image", "capture"],

      // Necesario para filtrado y paginación
      currentPage: 1,
      totalRows: 0,
      rowPerPage: 10,
      selectOptions: [] as { label: string; value: string }[],
      selectedValue: "",
      searchQuery: "",
      startDate: "",
      endDate: "",
    };
  },
  async mounted() {
    const station = await getDetailStation(this.station);
    this.stationDetail = station.lastData;

    this.getData();
  },

  methods: {
    getUnit(datastation: DataStation) {
      let unit = "";
      if (datastation.magnitude === "voltage") {
        unit = "V";
      } else if (
        datastation.magnitude === "humedity_int" ||
        datastation.magnitude === "available_SD"
      ) {
        unit = "%";
      } else if (datastation.magnitude === "temp_int") {
        unit = "ºC";
      }

      return unit;
    },
    convertMeasurement(magnitude: string, measurement: string) {
      if (measurement === "1") {
        if (
          magnitude === "optical_operation" ||
          magnitude === "state_SD" ||
          magnitude === "image"
        ) {
          measurement = "Correcto";
        } else if (magnitude === "capture") {
          measurement = "Continua";
        }
      } else if (measurement === "0") {
        if (
          magnitude === "optical_operation" ||
          magnitude === "state_SD" ||
          magnitude === "image"
        ) {
          measurement = "ERROR";
        } else if (magnitude === "capture") {
          measurement = "Masiva";
        }
      }

      return measurement;
    },
    getData() {
      if (this.stationDetail) {
        for (let data of this.stationDetail) {
          const unit = this.getUnit(data);
          let measurement = this.convertMeasurement(data.magnitude ?? "-", data.measurement);

          if (!isNaN(Number(measurement))) {
            // measurement = i18n.global.n(Number(data.measurement), "rounded");
            measurement = data.measurement;
          }

          const dataItem: DataItem = { id: 0, magnitude: "", measurement: "", unit: "", type: "" };

          dataItem.id = data.id;
          dataItem.magnitude = data.magnitude;
          dataItem.measurement = measurement;
          dataItem.unit = unit;
          dataItem.type = data.type;
          this.data.push(dataItem);
        }
      }
    },

    getSelectOptions() {
      if (this.parametersSelect.includes(this.magnitude as string)) {
        this.searchQuery = "";

        getDistinctMeasurements(this.station, this.magnitude as string)
          .then((measurements) => {
            measurements.forEach((measurement) => {
              let convertedMeasurement = this.convertMeasurement(
                this.magnitude as string,
                measurement
              );

              if (!this.selectOptions.some((option) => option.value === measurement)) {
                this.selectOptions.push({
                  label: convertedMeasurement,
                  value: measurement,
                });
              }
            });
          })
          .catch((error) => console.error("Error fetching distinct measurements:", error));
      }
    },

    getParameter(item: DataItem) {
      this.magnitude = item.magnitude;
    },

    async handleParameterClick(dataStation: any) {
      await this.onParameterClick(dataStation.magnitude, dataStation.measurement, dataStation.type);
      this.magnitude = dataStation.magnitude;

      if (isTextMeasurement(dataStation.measurement)) {
        await this.applyFilters();
        this.isPopupVisible = true;
      }
    },

    async fetchHistoryData(
      magnitude: string,
      page = 1,
      startDate?: Date,
      endDate?: Date,
      query?: string
    ) {
      try {
        if (endDate) {
          endDate.setHours(23, 59, 59, 999);
        }

        const operationalData = await getDataHistoric(
          this.station,
          magnitude,
          page,
          this.rowPerPage,
          startDate ? startDate.toISOString() : undefined,
          endDate ? endDate.toISOString() : undefined,
          query ? query : undefined
        );

        // Generar opciones del select
        this.getSelectOptions();

        // Transformar los datos a la estructura esperada
        operationalData.data.forEach((item) => {
          item.measurement = this.convertMeasurement(item.magnitude ?? "-", item.measurement);
        });

        this.historyData = operationalData.data.map((item: DataStation) => ({
          date: item.dateTime ? new Date(item.dateTime).toLocaleString() : "Fecha no disponible",
          value: item.measurement,
        }));

        // Actualizar el total de filas para la paginación
        this.totalRows = operationalData.totalRows;
      } catch (error) {
        console.error("Error al obtener datos históricos: ", error);
      }
    },

    async applyFilters() {
      const query = this.searchQuery != "" ? this.searchQuery.toLowerCase() : this.selectedValue;
      const startDateFilter = this.startDate ? new Date(this.startDate) : undefined;
      const endDateFilter = this.endDate ? new Date(this.endDate) : undefined;

      await this.fetchHistoryData(
        this.magnitude as string,
        this.currentPage,
        startDateFilter,
        endDateFilter,
        query
      );
    },

    resetFilters() {
      this.currentPage = 1;
      this.startDate = "";
      this.endDate = "";
      this.selectOptions = [];
      this.selectedValue = "";
      this.searchQuery = "";

      this.applyFilters();
    },

    changePaginationSize(newSize: number) {
      this.rowPerPage = newSize;
      this.currentPage = 1;
      this.applyFilters();
    },

    changePaginationPage(newPage: number) {
      this.currentPage = newPage;
      this.applyFilters();
    },

    classDataCard(dataStation: any) {
      let classDataCard = "data-card click";
      if (dataStation.magnitude) {
        if (dataStation.magnitude === this.parameter) {
          classDataCard = "data-card selected";
        }
        // if (dataStation.magnitude === "log_present") {
        //   classDataCard = "data-card";
        // }
      }
      return classDataCard;
    },
  },
});
